var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16308 14.3645L6.593 16.9228L11.7084 8.06084L7.27992 5.50254L2.16454 14.366L2.16308 14.3645ZM1.61792 15.7387L2.36915 19.1259L5.67808 18.0821L1.61792 15.7387ZM8.00923 4.23655L12.4377 6.79485L13.7326 4.55378L9.30269 1.99548L8.00923 4.23655ZM0 15.1905L8.76923 0L15.7291 4.01873L6.96131 19.2107H6.96277L1.28908 21L0 15.1905ZM8.76923 20.9985V19.5367H19V20.9985H8.76923Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e50afed732245190b7e8ce9657f370e9.svg";
export { ForwardRef as ReactComponent };